export default "__VITE_ASSET__e92d16a7__"